import React from 'react'
import { Card, CardHeader, CardBody, } from 'reactstrap'
import { AssessSkillBar } from '..';
import forOwn from 'mout/object/forOwn'
import { Link,Redirect } from 'react-router-dom'
import uuid from 'uuid/v1'



export default function SubtestReportSkillGroupCard({ report, title, color ,props,routeParams,query,isCompare,assessmentId,isSwap}) {
  let linkto1 = null
  if(routeParams && query){
      linkto1 = `/assessment/testing/${routeParams.userAssessmentId}/${routeParams.subTestSetId}?a=${query.a ? query.a : assessmentId}&g=${query.g ? query.g : 'true'}&item=overview${query.s ? `&s=${query.s}` : ''}`
   
  }
  
  let skillBars = []
  if (report) {
    report.forEach((node) => {
      let myquery = `${linkto1}&nd=${node.id}` ;
      
      skillBars.push(
        <Link to = {`${linkto1}&nd=${node.id}`} style={{'textDecoration': "none"}} key={uuid()}>
          <AssessSkillBar
            nodeName={node.name}
            raw={node.raw}
            possible={node.possible}
            percent={isSwap ? Math.round(node.percent * 100) : node.percent1 ? Math.round(node.percent1 * 100) :  Math.round(node.percent * 100)}
            color={color}
            margin={`ml-${(node.level - 1) * 2}`}
            key={`AssessSkillBar${node.id}`}
            props = {props}
            percentCompare = {isSwap ? Math.round(node.percent1 * 100) : Math.round(node.percent * 100)}
            isCompare = {isCompare}
          />
         </Link>
      )
    })



  }

  return (
    <CardBody>
      <ul className='horizontal-bars type-2'>
        {skillBars}
      </ul>
    </CardBody>

  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessReport/SubtestReportSkillGroupCard.js